import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PriceSidebar from './PriceSidebar';
import Stepper from './Stepper';
import { clearErrors } from '../../actions/orderAction';
import { useSnackbar } from 'notistack';
// import { post } from '../../utils/paytmForm';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import MetaData from '../Layouts/MetaData';
import { Box, Container, Grid, Paper, Typography, Button } from '@mui/material';
import { load } from '@cashfreepayments/cashfree-js';

const Payment = () => {

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const theme = useTheme();
    // const elements = useElements();
    // const paymentBtn = useRef(null);

    const [payDisable, setPayDisable] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('cashfree');

    const { shippingInfo, cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);
    const { error } = useSelector((state) => state.newOrder);

    const totalPrice = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    const paymentData = {
        amount: Math.round(totalPrice),
        email: user.email,
        phoneNo: shippingInfo.phoneNo,
        shippingInfo,
        orderItems: cartItems,
        totalPrice,
    };

    // const order = {
    //     shippingInfo,
    //     orderItems: cartItems,
    //     totalPrice,
    // }

    const submitHandler = async (e) => {
        e.preventDefault();
        setPayDisable(true);

        try {
            const { data } = await axios.post('/api/v1/cashfree/process', paymentData);

            const cashfree = await load({
                mode: process.env.REACT_APP_CASHFREE_ENV === 'PROD' ? "production" : "sandbox",
                appId: process.env.REACT_APP_CASHFREE_APP_ID
            });

            const checkoutOptions = {
                paymentSessionId: data.payment_session_id,
                redirectTarget: "_self",
            };

            cashfree.checkout(checkoutOptions);

        } catch (error) {
            setPayDisable(false);
            enqueueSnackbar(error.response?.data?.error || error.message, { variant: "error" });
        }
    };

    useEffect(() => {
        if (error) {
            dispatch(clearErrors());
            enqueueSnackbar(error, { variant: "error" });
        }
    }, [dispatch, error, enqueueSnackbar]);

    return (
        <>
            <MetaData title="Shree Ji Secure Soft Tech: Secure Payment | Cashfree" />

            <Container maxWidth="lg" sx={{ mt: 12, mb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper' }}>
                            <Stepper activeStep={3}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                                    Payment Method
                                </Typography>
                                <RadioGroup
                                    aria-label="paymentMethod"
                                    defaultValue="cashfree"
                                    name="paymentMethod"
                                    value={paymentMethod}
                                    onChange={(e) => setPaymentMethod(e.target.value)}
                                >
                                    <FormControlLabel
                                        value="cashfree"
                                        control={<Radio />}
                                        label={
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                <img
                                                    draggable="false"
                                                    className="h-6 w-6 object-contain"
                                                    src="/cashfree.png"
                                                    alt="Cashfree Logo"
                                                />
                                                <Typography>Cashfree</Typography>
                                            </Box>
                                        }
                                    />
                                </RadioGroup>
                                <Button
                                    component="fieldset"
                                    variant="contained"
                                    color="primary"
                                    onClick={submitHandler}
                                    disabled={payDisable}
                                    sx={{
                                        mt: 3,
                                        py: 1.5,
                                    }}
                                >
                                    Pay ₹{totalPrice.toLocaleString()}
                                </Button>
                            </Stepper>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <PriceSidebar cartItems={cartItems} showDeliveryCharge={true} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};


export default Payment;